import Vue from 'vue';
import Vuex from 'vuex';
import config from '@/config';

// Modules
import auth from './modules/auth';
import brand from './modules/brand';
import errorPage from './modules/errorPage';
import loader from './modules/loader';
import locale from './modules/locale';

// Plugins
import refreshToken from './plugins/refreshToken';

Vue.use(Vuex);

const debug = config.env === 'development';

export default new Vuex.Store({
  modules: {
    auth,
    brand,
    errorPage,
    loader,
    locale,
  },
  plugins: [...(config.features.localAuth ? [refreshToken] : [])],
  strict: debug,
});
